module.exports = __webpack_public_path__ + "img/k5-21.259aed35.png";